export const SPECIAL_PRICE_ATTRIBUTE_TITLES = [
  'Atributo A',
  'Atributo B',
  'Atributo C',
  'Atributo D',
  'Atributo E'
]

export const FIRST_QUALIFIER_NUMBER = 2
export const LAST_QUALIFIER_NUMBER = 6

export const SPECIAL_PRICE_SCOPE_QUALIFIER_KEYS = [
  'qualifier_2',
  'qualifier_3',
  'qualifier_4',
  'qualifier_5',
  'qualifier_6'
]

export const SPECIAL_PRICE_STATUS_CONFIG = {
  active: {
    label: 'ACTIVO',
    backgroundColor: '#d8f3e4',
    color: '#0f7b47'
  },
  scheduled: {
    label: 'PROGRAMADO',
    backgroundColor: '#e3f0ff',
    color: '#2c64a7'
  },
  suspended: {
    label: 'SUSPENDIDO',
    backgroundColor: '#efefef',
    color: '#6b6b6b'
  },
  expired: {
    label: 'EXPIRADO',
    backgroundColor: '#efefef',
    color: '#6b6b6b'
  }
}

export const DEFAULT_SPECIAL_PRICE_STATUS_CONFIG = {
  label: 'DESCONOCIDO',
  backgroundColor: '#efefef',
  color: '#6b6b6b'
}

export const DEFAULT_SPECIAL_PRICE_RANGE = {
  min_qty: 1,
  max_qty: 1,
  special_price: ''
}
